import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import NumericInput from "react-numeric-input";

let timeLimitInMinutes;

const AreaSettingsTimeMonitoring = forwardRef((props, ref) => {
  const { t } = useTranslation();

  let jwt = localStorage.getItem("JWT");
  let link = localStorage.getItem("link");
  let data = props.data;

  const [timeHH, setTimeHH] = useState(0);
  const [timeMM, setTimeMM] = useState(0);
  const [timeDD, setTimeDD] = useState(0);
  const [timeActive, setTimeActive] = useState(false);

  const [original, setOriginal] = useState(null);
  const [saving, setSaving] = useState(false);

  const toMinutes = (DD, HH, MM) => DD * 1440 + HH * 60 + MM;

  const isDirty = () => {
    if (!original) return false;

    return (
      original.minutes !== toMinutes(timeDD, timeHH, timeMM) ||
      original.enabled !== timeActive
    );
  };

  useEffect(() => {
    let minutes;
    let enabled;
    if (data?.parkingTimeRestrictionInMinutes !== undefined) {
      minutes = data.parkingTimeRestrictionInMinutes;
      enabled = data.parkingTimeRestrictionEnabled;

      const DD = Math.floor(minutes / 1440);
      const HH = Math.floor((minutes % 1440) / 60);
      const MM = minutes % 60;

      setTimeDD(DD);
      setTimeHH(HH);
      setTimeMM(MM);
      setTimeActive(enabled);

      setOriginal({ minutes, enabled });
    } else {
      minutes = 0;
      enabled = false;
      setOriginal({ minutes, enabled });
    }
  }, [props.data]);

  const save = async () => {
    if (!isDirty() || saving) return;

    setSaving(true);

    const restriction = toMinutes(timeDD, timeHH, timeMM);

    const subType = "Area";

    try {
      await axios.put(
        link +
          "/api/" +
          subType +
          "/ParkingTimeRestriction?restriction=" +
          restriction +
          "&enabled=" +
          timeActive +
          "&elementId=" +
          data.id,
        {
          headers: {
            Authorization: "Bearer " + jwt,
          },
        },
      );

      setOriginal({
        minutes: restriction,
        enabled: timeActive,
      });
    } finally {
      setSaving(false);
    }
  };

  const reset = () => {
    if (!original) return;

    const { minutes, enabled } = original;

    const DD = Math.floor(minutes / 1440);
    const HH = Math.floor((minutes % 1440) / 60);
    const MM = minutes % 60;

    setTimeDD(DD);
    setTimeHH(HH);
    setTimeMM(MM);
    setTimeActive(enabled);
  };

  useImperativeHandle(ref, () => ({
    save,
    reset,
    isDirty,
  }));

  return (
    <div className="settings-groups">
      <div className="settings-name">
        {t("elementeAllgemein.zeitueberwachung")}
      </div>

      <div className="flex-sb">
        <div className="select-switch">
          {t("allgemein.aktiv")}
          <label class="switch">
            <input
              type="checkbox"
              checked={timeActive}
              class="switch-input"
              onChange={() => setTimeActive((current) => !current)}
            />
            <span
              class="switch-label"
              data-on={t("allgemein.an")}
              data-off={t("allgemein.aus")}
            ></span>
            <span class="switch-handle"></span>
          </label>
        </div>
        <div className="flex-sb">
          <div className="flex-sb ">
            <div style={{ marginRight: "5px" }}>DD</div>
            <NumericInput
              value={timeDD}
              onChange={(e) => setTimeDD(e)}
              className="input-numeric input-we2"
              mobile={"auto"}
              min={0}
              max={999}
            />
          </div>
          <div className="flex-sb ">
            <div style={{ marginRight: "5px", marginLeft: "5px" }}>HH</div>
            <NumericInput
              value={timeHH}
              onChange={(e) => setTimeHH(e)}
              className="input-numeric input-we2"
              mobile={"auto"}
              min={0}
              max={23}
            />
          </div>
          <div className="flex-sb ">
            <div style={{ marginRight: "5px", marginLeft: "5px" }}>MM</div>
            <NumericInput
              value={timeMM}
              onChange={(e) => setTimeMM(e)}
              className="input-numeric input-we2"
              mobile={"auto"}
              min={0}
              max={59}
            />
          </div>
        </div>
      </div>
    </div>
  );
});
export default AreaSettingsTimeMonitoring;
